import { useRouter } from 'next/navigation';

import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Metrics } from '@shared/types/enums/metrics.enum';
import { ProductCardType } from '@shared/types/product';
import { sendMetrics } from '@shared/utils/sendMetrics/sendMetrics';

import { addProductToCartThunk } from '../';

export const useAddToCartHandle = (props: ProductCardType) => {
  const dispatch = useAppDispatch();
  const { push } = useRouter();
  const cartProducts = useAppSelector((state) => state.cart.productIds);

  const id = props.id;

  const productInCart = cartProducts.includes(id);

  const handleClickAddToCart = async () => {
    if (productInCart) {
      push(ROUTES.CART);
    } else {
      await dispatch(addProductToCartThunk(props));

      sendMetrics(Metrics.ADD_TO_CART, {
        ecommerce: {
          add: {
            products: [props]
          }
        }
      });
    }
  };

  return { productInCart, handleClickAddToCart };
};
